<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="批次：" prop="batch">
                <span>{{model.batch}}</span>
            </el-form-item>
            <el-form-item label="省份：" prop="province">
                <span>{{model.province}}</span>
            </el-form-item>
            <el-form-item label="城市：" prop="city">
                <span>{{model.city}}</span>
            </el-form-item>
            <el-form-item label="RN码：" prop="rn">
                <span>{{model.rn}}</span>
            </el-form-item>
            <el-form-item label="RN码-1：" prop="rn1">
                <span>{{model.rn1}}</span>
            </el-form-item>
            <el-form-item label="下单时间：" prop="order_time">
                <span>{{model.order_time}}</span>
            </el-form-item>
            <el-form-item label="更新时间：" prop="update_time">
                <span>{{model.update_time}}</span>
            </el-form-item>
            <el-form-item label="交付时间：" prop="deliver_time">
                <span>{{model.deliver_time}}</span>
            </el-form-item>
            <el-form-item label="型号：" prop="model">
                <span>{{model.model}}</span>
            </el-form-item>
            <el-form-item label="版本：" prop="banben">
                <span>{{model.banben}}</span>
            </el-form-item>
            <el-form-item label="颜色：" prop="yanse">
                <span>{{model.yanse}}</span>
            </el-form-item>
            <el-form-item label="轮毂：" prop="lungu">
                <span>{{model.lungu}}</span>
            </el-form-item>
            <el-form-item label="内饰：" prop="neishi">
                <span>{{model.neishi}}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'deliveryInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                batch: '',
                province: '',
                city: '',
                rn: '',
                order_time: '',
                update_time: '',
                deliver_time: '',
                model: '',
                banben: '',
                yanse: '',
                lungu: '',
                neishi: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/delivery/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>